/** The fewest characters a password may have that a user sets for themselves. */
export const MIN_PASSWORD_LENGTH = 12;

// Code of the Parse error with which the server refuses a user's change of
// their password when the current password is missing or wrong. An application
// code, as SECOND_FACTOR_REQUIRED is.
export const CURRENT_PASSWORD_WRONG = 1002;
